import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { ChartModule } from 'angular2-chartjs';
import { CommonModule } from '@angular/common';
import { CovalentSearchModule  } from '@covalent/core/search';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPrintModule } from 'ngx-print';
import { QRCodeModule } from 'angularx-qrcode';
import { TagInputModule } from 'ngx-chips';
import { TranslateModule } from '@ngx-translate/core';

import { BoolToWordPipe } from './../../pipes/bool-to-word.pipe';
import { CardWhiteGuidesComponent } from '../../components/card-white-guides/card-white-guides.component';
import { CarouselComponent } from '../../components/carousel/carousel.component';
import { CarrierGroupProvider } from '../../providers/carrier-group/carrier-group.provider.service';
import { CorrectMisspellingPipe } from '../../pipes/correct-misspelling.pipe';
import { DeliveryDetailComponent } from '../../components/delivery-detail/delivery-detail.component';
import {
  DialogAssignCarriersComponent
} from '../../components/dialog/dialog-marketplace/dialog-assign-carriers/dialog-assign-carriers.component';
import {
  DialogAssociateShipmentComponent
} from '../../components/dialog/dialog-marketplace/dialog-associate-shipment/dialog-associate-shipment.component';
import { DialogDynamicLocationComponent } from '../../components/dialog/dialog-dynamic-location/dialog-dynamic-location.component';
import { DragAndDropComponent } from '../../components/drag-and-drop/drag-and-drop.component';
import { ExcelService } from '../../services/utils/excel-tools.service';
import { ExcelServiceReport } from '../../pages/reports/costing-sheets-report/utils/excel-tools.service';
import {
  EvidenceReleaseFolioDocumentComponent
} from '../../pages/evidence/evidence-release-folio-document/evidence-release-folio-document.component';
import { GeoLocationService } from '../../services/utils/get-position.service';
import { LanguageTranslateService } from '../../services/translate/language-translate.service';

import { EvidenceFolioFormatComponent } from '../../pages/evidence/evidence-folio-format/evidence-folio-format.component';
import { HomeComponent } from '../../pages/home/home.component';
import { IndicatorsProvider } from '../../providers/indicators/indicators-provider.service';
import { LazyTranslateModule } from './lazy-translate.module';
import { LoadPlanComponent } from '../../pages/shipments/load-plan/load-plan.component';
import { ManualDeliveryComponent } from '../../pages/evidence/manual-delivery/manual-delivery.component';
import { MapLocationComponent } from '../../components/map-location/map-location.component';
import { MapsProvider } from '../../providers/maps/maps-provider.service';
import { MarketplaceService } from '../../services/marketplace/marketplace.service';
import { MaterialModule } from '../material/material.module';
import { MiniCarouselComponent } from '../../components/mini-carousel/mini-carousel.component';
import { MultipleInputSearchComponent } from '../../components/multiple-input-search/multiple-input-search.component';
import { NoDataPipe } from './../../pipes/no-data.pipe';
import { NoInfoComponent } from '../../components/no-info/no-info.component';
import { NumberOnlyDirectiveModule } from '../directives/number-only-directive.module';
import { OrderLabelViewComponent } from '../../components/order-label-view/order-label-view.component';
import { RateComponent } from '../../components/marketplace/rate/rate.component';
import { ResponseInterceptorProvider } from '../../providers/response-interceptor/response-interceptor.service';
import { SatDatepickerModule, SatNativeDateModule } from 'saturn-datepicker';
import { ScfChartModule, ScfCardModule, ScfExcelImportModule, ScfLoaderModule } from 'scf-library';
import { SelectSearchComponent } from '../../components/select-search/select-search.component';
import { ShareLoadPlanService } from '../../services/share-load-data/share-load-plan.service';
import { ShipmentCommunicationService } from '../../services/shipment.service';
import { StarRateComponent } from '../../components/star-rate/star-rate.component';
import { StarRatingComponent } from '../../components/marketplace/star-rating/star-rating.component';
import { ShipmentCardInfoComponent } from '../../components/shipment-card-info/shipment-card-info.component';
import {
  ShipmentRequestFormatComponent
} from '../../components/dialog/dialog-shipment-request-format/dialog-shipment-request-format.component';
import { ShipmentsService } from '../../providers/shipments/shipments.service';
import { StepperDynamicComponent } from '../../components/stepper-dynamic/stepper-dynamic.component';
import { SubtitleDividerComponent } from '../../components/subtitle-divider/subtitle-divider.component';
import { TokenInterceptorProvider } from '../../providers/token-interceptor/token-interceptor.service';
import { UserWarehouseComponent } from '../../components/user-warehouse/user-warehouse.component';
import { ReportFilterSearchComponent } from '../../components/report-filter-search/report-filter-search.component';

const sharedComponents = [
  BoolToWordPipe,
  CardWhiteGuidesComponent,
  CarouselComponent,
  CorrectMisspellingPipe,
  DeliveryDetailComponent,
  DialogAssignCarriersComponent,
  DialogAssociateShipmentComponent,
  DialogDynamicLocationComponent,
  DragAndDropComponent,
  EvidenceReleaseFolioDocumentComponent,
  EvidenceFolioFormatComponent,
  HomeComponent,
  LoadPlanComponent,
  ManualDeliveryComponent,
  MapLocationComponent,
  MiniCarouselComponent,
  MultipleInputSearchComponent,
  NoDataPipe,
  NoInfoComponent,
  RateComponent,
  ShipmentCardInfoComponent,
  ShipmentRequestFormatComponent,
  SelectSearchComponent,
  StarRateComponent,
  StarRatingComponent,
  StepperDynamicComponent,
  SubtitleDividerComponent,
  UserWarehouseComponent,
  ReportFilterSearchComponent,
  OrderLabelViewComponent
];

const sharedModules =  [
  AgmCoreModule,
  AgmDirectionModule,
  ChartModule,
  CommonModule,
  CovalentSearchModule,
  FlexLayoutModule,
  FormsModule,
  HttpClientModule,
  MaterialModule,
  NgxBarcodeModule,
  NgxDropzoneModule,
  NgxMatSelectSearchModule,
  NgxPrintModule,
  NumberOnlyDirectiveModule,
  QRCodeModule,
  ReactiveFormsModule,
  SatDatepickerModule,
  SatNativeDateModule,
  ScfCardModule,
  ScfChartModule,
  ScfLoaderModule,
  ScfExcelImportModule,
  TagInputModule
];

const sharedProviders = [
  CarrierGroupProvider,
  ExcelService,
  ExcelServiceReport,
  GeoLocationService,
  IndicatorsProvider,
  MarketplaceService,
  MapsProvider,
  ShareLoadPlanService,
  ShipmentCommunicationService,
  ShipmentsService,
  LanguageTranslateService,
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorProvider, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptorProvider, multi: true}
];

const exportsModules = [
  ...sharedComponents, ...sharedModules
];

const exportEntryComponents = [
  DialogDynamicLocationComponent
];

@NgModule({
  declarations: sharedComponents,
  imports: [...sharedModules, LazyTranslateModule],
  providers: sharedProviders,
  exports: [...exportsModules, TranslateModule],
  entryComponents: exportEntryComponents
})
export class SharedModule { }
